import React, { useMemo, useState } from "react";

import { useIntl } from "react-intl";

import { ObservabilityPipelineHttpMetricsOverview } from "Api/observability/pipeline/types";
import { Tooltip } from "ds/Tooltip";
import LeftEllipsis from "src/organization/pages/project/environment/metrics/components/LeftEllpisis/LeftEllipsis";
import { Flex } from "src/organization/pages/project/environment/metrics/components/tooltip/style";
import RoundLegend from "src/organization/pages/project/environment/metrics/http2/components/RoundLegend";
import { formatNumber } from "src/organization/pages/project/environment/metrics/http2/helper";

import * as S from "./styles";
import { TimeRangeImpactType } from "./type";

type SortOrderType = {
  by: keyof TimeRangeImpactType;
  order: "asc" | "dsc";
};

const ImpactTable = ({
  httpMetricsOverview
}: {
  httpMetricsOverview:
    | ObservabilityPipelineHttpMetricsOverview
    | null
    | undefined;
}) => {
  const intl = useIntl();

  // TODO disabled feature enable when filtering by table type is included
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sort, setSort] = useState<SortOrderType>({
    by: "impact",
    order: "dsc"
  });

  const urls = useMemo(() => {
    return Object.values(httpMetricsOverview?.data?.urls ?? {}).sort((a, b) =>
      sort.order === "asc"
        ? (a[sort.by] as number) - (b[sort.by] as number)
        : (b[sort.by] as number) - (a[sort.by] as number)
    );
  }, [httpMetricsOverview, sort]);

  //TODO disabled feature enable when filtering by table type is included
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const changeOrder = (by: keyof TimeRangeImpactType) => {
    // setSort(prevSort => ({
    //   by,
    //   order: prevSort.order === "asc" ? "dsc" : "asc"
    // }));
  };

  return (
    <div>
      <S.Table>
        <S.UrlTitle
          id="urlContainerId"
          onClick={() => {
            changeOrder("url");
          }}
        >
          {intl.formatMessage({ id: "url" })}
        </S.UrlTitle>

        <S.ImpactTitle>
          {intl.formatMessage({ id: "http.impact" })}
        </S.ImpactTitle>
        <S.ItemTitle
          onClick={() => {
            changeOrder("count");
          }}
        >
          {intl.formatMessage({ id: "http.requests" })}
        </S.ItemTitle>
        <S.ItemTitle
          onClick={() => {
            changeOrder("avgDuration");
          }}
        >
          {intl.formatMessage({ id: "http.response_time.avg" })}
        </S.ItemTitle>
        <S.ItemTitle
          onClick={() => {
            changeOrder("p95Duration");
          }}
        >
          {intl.formatMessage({ id: "http.response_time.p95" })}
        </S.ItemTitle>
        <S.ItemTitle
          onClick={() => {
            changeOrder("method");
          }}
        >
          {intl.formatMessage({ id: "http.method" })}
        </S.ItemTitle>
      </S.Table>

      {urls.length ? (
        urls.map((impact, i) => {
          return (
            <S.Table key={i}>
              <S.Item className="value impact">
                <Flex className="impact-url-wrapper">
                  <div>
                    <RoundLegend color={impact.color} />
                  </div>

                  <Tooltip
                    align="start"
                    tooltip={impact.url}
                    analyticId="impact_url"
                  >
                    <LeftEllipsis text={impact.url} />
                  </Tooltip>
                </Flex>
              </S.Item>
              <S.Item className="value impact-percent">
                {impact.impact.toFixed(1)}%
              </S.Item>
              <S.Item>{formatNumber({ value: impact.count })}</S.Item>
              <S.Item>{impact.average.toFixed(1)}ms</S.Item>
              <S.Item>{impact.p_96.toFixed(1)}ms</S.Item>
              <S.Item>{impact.method}</S.Item>
            </S.Table>
          );
        })
      ) : (
        <div>
          <S.Item>
            <S.NoData>{intl.formatMessage({ id: "no_data" })}</S.NoData>
          </S.Item>
        </div>
      )}
    </div>
  );
};

export default ImpactTable;
